import React from 'react';
import CustomTempDrawer from '../common/CustomTempDrawer';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { pubArtifactsWarnMsg } from '../../Constants/Files';

const PublishedArtifactsWarningDrawer = (props) => {
	const { primaryBtnClick, open, setOpen } = props;
	const handleDrawerBtnClick = () => {
		primaryBtnClick();
	};
	const tempDrawerProps = {
		open: open,
		setOpen: setOpen,
		header: 'Irreversible change',
		confirmationMessage: props.msg ?? pubArtifactsWarnMsg,
		primaryBtnStartIcon: <CheckCircleIcon />,
		primaryBtnTxt: `YES`,
		primaryButtonClick: handleDrawerBtnClick,
	};
	return (
		<div>
			<CustomTempDrawer {...tempDrawerProps}></CustomTempDrawer>
		</div>
	);
};

export default PublishedArtifactsWarningDrawer;
